export const BLOCK_ALIGNMENT = {
    'left': 'bg-justify-left',
    'centre': 'bg-justify-center',
    'right': 'bg-justify-right'
}
export const TEXT_ALIGNMENT = {
    "centre": "bg-align-text-centre bg-align-items-centre",
    "left": "bg-align-text-left bg-align-items-left",
    "right": "bg-align-text-right bg-align-items-right",
}

export const BUTTON_COLORS = {
    "button - primary": "gradient-blue",
    "button - secondary": "blue",
    "button - header": "header-button",
}


